import React, { memo } from 'react';
import CampaignHeader from '../../shared/CampaignHeader';
import CampaignProgressMeta from '../../shared/CampaignHeader/components/CampaignProgressMeta';

/**
 * GanttHeader Component
 * 
 * Uses the shared CampaignHeader component for breadcrumb, icon, and title.
 * Adds Gantt-specific progress stats (text-only).
 */
const GanttHeader = memo(({
  campaignName,
  campaignIcon,
  campaignProgress,
  breadcrumbPath = [],
  completedCount,
  totalCount,
  remainingMinutes = 0,
  remainingMinMinutes,
  missingEstCount = 0,
  remainingBreakdown = [],
  onSelectSprint,
  onSprintIconChange,
  onRenameSprint,
}) => {
  if (!campaignName) return null;

  return (
    <CampaignHeader
      name={campaignName}
      icon={campaignIcon}
      breadcrumbPath={breadcrumbPath}
      onRename={onRenameSprint}
      onIconChange={onSprintIconChange}
      onSelectSprint={onSelectSprint}
      classPrefix="gantt-header"
    >
      <CampaignProgressMeta
        completedCount={completedCount}
        totalCount={totalCount}
        remainingMinutes={remainingMinutes}
        remainingMinMinutes={remainingMinMinutes}
        missingEstCount={missingEstCount}
        remainingBreakdown={remainingBreakdown}
        progressPercent={campaignProgress}
        includeProgressPercent
        className="gantt-header__stats"
        countClassName="gantt-header__stats-text"
      />
    </CampaignHeader>
  );
});

GanttHeader.displayName = 'GanttHeader';

export default GanttHeader;
